import { DEFAULT_APP_ENVIRONMENT } from './global';
import { AppEnvironment } from './network';
import { ActionConstantsInterface } from './types';

export enum ActionStatus {
  UNINITIATED = 'UNINITIATED',
  SUCCESS = 'SUCCESS',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
}

export enum ActionConstantEnums {
  // PUBLIC ACTIONS
  PUBLIC_ACTION_ID,
  APPROVE_CAMPAIGN_ACTION_ID,
  EDIT_USER,
  ADD_NEW_USER,
  DISABLE_USER,
  APPROVALS_APPROVE,
  APPROVALS_APPROVE_PO_VIEW,
  APPROVALS_APPROVE_JOBS_VIEW,
  APPROVALS_REJECT,
  SKU_REVIEW_CATALOG,
  SKU_LIST_CATALOG,
  SKU_UPSERT_CATALOG,
  USER_MANAGEMENT_GET_ALL_USERS,
  USER_MANAGEMENT_CREATE_EXTERNAL_USER,
  VIEW_ASN,
  CREATE_ASN,
  RETRY_REPORTS,
  DOWNLOAD_REPORTS,
  CREATE_REPORT_REQUEST,
  GET_ALL_REPORTS,
  CREATE_STORE_ENTITY,
  CREATE_ENTITY,
  UPDATE_STATE_ENTITY,
  UPDATE_STORE_ENTITY,
  CREATE_STATE_ENTITY,
  UPDATE_ENTITY,
  BULK_PO_GET_UPLOAD_URL_LINK,
  BULK_PO_GET_DOWNLOAD_URL_LINK,
  BULK_PO_FINALIZE_UPLOAD,
  PO_LINE_ITEMS_EDIT_VIEW,
  PO_SUMMARY,
  PO_VIEW,
  PO_LINE_ITEMS_EDIT,
  PO_LINE_ITEM_SUMMARY,
  VIEW_MARGIN_UPLOADS,
  GET_MARGINS,
  CREATE_MARGINS,
  BULK_JOBS_APPROVE,
  BULK_JOBS_REJECT,
  BULK_PO_REFRESH,
  BULK_PO_APPROVE,
  BULK_PO_EXPIRE,
  BULK_PO_CANCEL,
  BULK_PO_LINE_ITEM_UPDATE,
  BULK_PO_UPDATE,
  APPROVE_BULK_PO_REFRESH,
  APPROVE_BULK_PO_APPROVE,
  APPROVE_BULK_PO_EXPIRE,
  APPROVE_BULK_PO_CANCEL,
  APPROVE_BULK_PO_LINE_ITEM_UPDATE,
  APPROVE_BULK_PO_UPDATE,
  CANCEL_BULK_PO_REFRESH,
  CANCEL_BULK_PO_APPROVE,
  CANCEL_BULK_PO_EXPIRE,
  CANCEL_BULK_PO_CANCEL,
  CANCEL_BULK_PO_LINE_ITEM_UPDATE,
  CANCEL_BULK_PO_UPDATE,
}

const QAActions: ActionConstantsInterface = {
  PUBLIC_ACTION_ID: 'PUBLIC_ACTION_ID',
  APPROVE_CAMPAIGN_ACTION_ID: 'PUBLIC_ACTION_ID',
  EDIT_USER: 'PUBLIC_ACTION_ID',
  ADD_NEW_USER: 'PUBLIC_ACTION_ID',
  DISABLE_USER: 'PUBLIC_ACTION_ID',
  APPROVALS_APPROVE: '4be4c48d-ca25-4f05-9b5d-98a9d8faddd6',
  APPROVALS_APPROVE_PO_VIEW: 'f3b14fcd-033a-4d01-81a7-1fcf048a5787',
  APPROVALS_APPROVE_JOBS_VIEW: '9329b2da-93d0-41cd-81f3-b1667748bd80',
  APPROVALS_REJECT: '26927f2d-afea-44aa-b57e-60e700729ebe',
  SKU_REVIEW_CATALOG: '344f3765-a059-43fb-9238-effe5d7a5f20',
  SKU_LIST_CATALOG: '9151ae1d-e312-487e-818b-d552e250a22f',
  SKU_UPSERT_CATALOG: 'e5a40a0f-013e-42e5-a72d-4142863e39bf',
  USER_MANAGEMENT_GET_ALL_USERS: 'f92d5519-ef2b-4ec8-9ae8-ede22ce01532',
  USER_MANAGEMENT_CREATE_EXTERNAL_USER: '6e22c506-9980-496c-aa80-4d2e926692e9',
  VIEW_ASN: '0f33e620-e1a1-4e8b-b439-1195a880c6e2',
  CREATE_ASN: 'f5d309d8-f866-4b28-81eb-8fb9b9aeb3d8',
  RETRY_REPORTS: '551bee2e-8c48-4cd0-a958-6954e2d3179d',
  DOWNLOAD_REPORTS: 'eaf98e04-661e-49e6-8755-b06caa6bde62',
  CREATE_REPORT_REQUEST: '2159ef5c-534c-4cbc-85c2-50507b5d5903',
  GET_ALL_REPORTS: '739c64d0-dd62-48be-8abf-c252d805736f',
  CREATE_STORE_ENTITY: 'd2dba1a3-e489-41c2-8395-a349901c0aac',
  CREATE_ENTITY: 'f7a36bd9-b5f8-4d7a-94d7-fa20773448b3',
  UPDATE_STATE_ENTITY: '68f614c5-dd5b-4a6c-9635-049a9b7060bb',
  UPDATE_STORE_ENTITY: '95b9f96e-3a39-4c45-851c-825fb26cacdb',
  CREATE_STATE_ENTITY: '98af1209-270d-4289-99ff-70deca8c3fdb',
  UPDATE_ENTITY: 'b88a0ff0-742d-4c6a-951e-b2d6b0fd11e1',
  BULK_PO_GET_UPLOAD_URL_LINK: '5a349476-b024-47ac-b3f2-f9a1178a7059',
  BULK_PO_GET_DOWNLOAD_URL_LINK: '991b3c31-7dd6-425a-aa4f-05f2e3e9e636',
  BULK_PO_FINALIZE_UPLOAD: 'b203338a-c7e4-412a-937a-36588182292b',
  PO_LINE_ITEMS_EDIT_VIEW: 'f2ab65eb-f11c-4fa7-86f7-35579df19842',
  PO_SUMMARY: 'cfe91548-b4ec-49c4-a43d-a923fb47fa2f',
  PO_VIEW: '1661b1af-cc83-46f0-9474-1313e1ff0a44',
  PO_LINE_ITEMS_EDIT: 'b09da618-fe18-4e70-96a3-8eaff1203bf5',
  PO_LINE_ITEM_SUMMARY: 'c21de159-9daf-4181-9f02-23de600efa6b',
  VIEW_MARGIN_UPLOADS: '4f632f0c-7511-40b6-8e5a-09e4647d4c2f',
  GET_MARGINS: 'e0ab269a-ccbf-4273-9b3a-094a2cc5fcb9',
  CREATE_MARGINS: 'c6a49881-64b3-4b7c-9be5-19c0b105013a',
  BULK_JOBS_APPROVE: '71d978c3-8750-484e-a367-485b920c9802',
  BULK_JOBS_REJECT: '4f02ec93-8e4b-4aac-85f5-5f71255a83bb',
  BULK_PO_REFRESH: '2b519a48-e36b-429b-9deb-6d15172aee6b',
  BULK_PO_APPROVE: '168b415d-7ec5-46dd-bb2f-e56772036ea5',
  BULK_PO_EXPIRE: '2ca9fa22-c3a8-4521-839c-d3f3768fc851',
  BULK_PO_CANCEL: '17c1f0b1-6c99-461e-9952-3593bea20c4b',
  BULK_PO_LINE_ITEM_UPDATE: 'f3460414-b8a1-451c-94a0-140673475ea4',
  BULK_PO_UPDATE: '3399f4f6-de0f-48bd-9f83-cd77719dcf18',
  APPROVE_BULK_PO_REFRESH: '5f3a29a3-a021-405d-99f5-521c4b4135af',
  APPROVE_BULK_PO_APPROVE: '521c6acc-7e98-46dc-9f49-a69c517d4631',
  APPROVE_BULK_PO_EXPIRE: '3262a037-152a-49d5-9c3e-df650d52fbfb',
  APPROVE_BULK_PO_CANCEL: '16c8037d-0118-4a2d-ba62-9c0fc6a584d8',
  APPROVE_BULK_PO_LINE_ITEM_UPDATE: '651a1b1e-9c06-4d34-96e1-a1862e5f9bf8',
  APPROVE_BULK_PO_UPDATE: '4e38a15d-e535-4b86-8923-cce3a9b941d0',
  CANCEL_BULK_PO_REFRESH: '77d3fb28-5b10-4172-a7bc-d857a5be74ad',
  CANCEL_BULK_PO_APPROVE: '7e424793-749a-45b2-8dd5-49751bfb35bd',
  CANCEL_BULK_PO_EXPIRE: 'dd7ebe8c-1d46-4009-a466-24bafe071b50',
  CANCEL_BULK_PO_CANCEL: 'de52500c-ab72-4d46-ae95-13cda226df33',
  CANCEL_BULK_PO_LINE_ITEM_UPDATE: 'c35e323e-3963-4623-8954-89fd63e9066b',
  CANCEL_BULK_PO_UPDATE: '043df31f-7f6e-4280-b103-d37995a62f23',
};

const ProdActions: ActionConstantsInterface = {
  PUBLIC_ACTION_ID: 'PUBLIC_ACTION_ID',
  APPROVE_CAMPAIGN_ACTION_ID: 'PUBLIC_ACTION_ID',
  EDIT_USER: 'PUBLIC_ACTION_ID',
  ADD_NEW_USER: 'PUBLIC_ACTION_ID',
  DISABLE_USER: 'PUBLIC_ACTION_ID',
  APPROVALS_APPROVE: '24bda90a-fc1b-4990-9b47-aac5e2662b4f',
  APPROVALS_APPROVE_PO_VIEW: '0932d569-0139-49e5-88ae-dfbd66dc5853',
  APPROVALS_APPROVE_JOBS_VIEW: 'c9d9e3b9-682e-46f9-84e8-9079e2dac1e9',
  APPROVALS_REJECT: 'e79c81d7-2fec-4be5-95da-2d405059a84c',
  SKU_REVIEW_CATALOG: '344f3765-a059-43fb-9238-effe5d7a5f20',
  SKU_LIST_CATALOG: '9151ae1d-e312-487e-818b-d552e250a22f',
  SKU_UPSERT_CATALOG: 'e5a40a0f-013e-42e5-a72d-4142863e39bf',
  USER_MANAGEMENT_GET_ALL_USERS: 'f92d5519-ef2b-4ec8-9ae8-ede22ce01532',
  USER_MANAGEMENT_CREATE_EXTERNAL_USER: '6e22c506-9980-496c-aa80-4d2e926692e9',
  VIEW_ASN: 'def9e82a-cb7f-4164-9fac-05f50f0c186a',
  CREATE_ASN: '970f1021-555e-447a-bb41-699a0693cfd2',
  RETRY_REPORTS: '551bee2e-8c48-4cd0-a958-6954e2d3179d',
  DOWNLOAD_REPORTS: 'eaf98e04-661e-49e6-8755-b06caa6bde62',
  CREATE_REPORT_REQUEST: '2159ef5c-534c-4cbc-85c2-50507b5d5903',
  GET_ALL_REPORTS: '739c64d0-dd62-48be-8abf-c252d805736f',
  CREATE_STORE_ENTITY: 'd2dba1a3-e489-41c2-8395-a349901c0aac',
  CREATE_ENTITY: 'f7a36bd9-b5f8-4d7a-94d7-fa20773448b3',
  UPDATE_STATE_ENTITY: '68f614c5-dd5b-4a6c-9635-049a9b7060bb',
  UPDATE_STORE_ENTITY: '95b9f96e-3a39-4c45-851c-825fb26cacdb',
  CREATE_STATE_ENTITY: '98af1209-270d-4289-99ff-70deca8c3fdb',
  UPDATE_ENTITY: 'b88a0ff0-742d-4c6a-951e-b2d6b0fd11e1',
  BULK_PO_GET_UPLOAD_URL_LINK: '027dafdb-9ac7-4cdf-839b-6323e1351f72',
  BULK_PO_GET_DOWNLOAD_URL_LINK: '3e4f844f-43c7-4f60-a1de-417eb51b8e78',
  BULK_PO_FINALIZE_UPLOAD: '073ebc50-dbff-4eed-b431-655b93c7c042',
  PO_LINE_ITEMS_EDIT_VIEW: '7da667b6-3b6f-46b3-a72e-4d2a6a7c450f',
  PO_SUMMARY: '316e114c-59f2-4a9e-be56-4d27172abd16',
  PO_VIEW: '7e7067a3-6424-471e-a417-d35cf9ec42cb',
  PO_LINE_ITEMS_EDIT: '2876624b-b1b1-4912-ab8b-0e0eecf769c5',
  PO_LINE_ITEM_SUMMARY: '8b501ed4-304f-40b3-88a9-ebf14a71b31e',
  VIEW_MARGIN_UPLOADS: 'cf06efe8-8a06-4d46-8272-e55fbf2bca0b',
  GET_MARGINS: 'cf2dbec0-fb95-42c4-a080-4444cf07451f',
  CREATE_MARGINS: 'b07a899d-c410-4bad-b5be-9f845ff1dcd2',
  BULK_JOBS_APPROVE: '687cf573-4a91-42e1-9444-7ce3327cc988',
  BULK_JOBS_REJECT: '2bbcd592-74c9-47f7-a76a-c74295de64fd',
  BULK_PO_REFRESH: 'ebd7aefe-9a8f-4021-801a-23186b3b4891',
  BULK_PO_APPROVE: '3dd8a813-aed5-4148-9147-d2a5fc8c315e',
  BULK_PO_EXPIRE: 'a09acddc-c983-4736-be5e-b4d36fe3837d',
  BULK_PO_CANCEL: '659e178d-0e12-4089-b57d-386a17741cf8',
  BULK_PO_LINE_ITEM_UPDATE: '3546b20b-945d-44c1-a5b7-25009b66124d',
  BULK_PO_UPDATE: '130140e8-7336-412e-95d4-1e572b2b998e',
  APPROVE_BULK_PO_REFRESH: '0c619750-5204-44ad-9fe4-12b97f3273e2',
  APPROVE_BULK_PO_APPROVE: '4263b601-2887-4901-a2b7-ab800088fa18',
  APPROVE_BULK_PO_EXPIRE: '1dc75373-4ee6-4647-befb-ee0ece10c5af',
  APPROVE_BULK_PO_CANCEL: 'd77187cd-9109-44b9-83f0-1a78ae1b9f00',
  APPROVE_BULK_PO_LINE_ITEM_UPDATE: 'ef5b4be8-c9ec-4aaa-9cb0-05c9986a8925',
  APPROVE_BULK_PO_UPDATE: 'a176c415-d650-415e-8c43-9e609da31178',
  CANCEL_BULK_PO_REFRESH: '3e5c6bd5-5410-4961-acb6-adc947519323',
  CANCEL_BULK_PO_APPROVE: '3d7eb36b-4926-4a87-8802-434089d8975e',
  CANCEL_BULK_PO_EXPIRE: '3338b7a4-f9aa-4f20-a93d-98c69c7c84a8',
  CANCEL_BULK_PO_CANCEL: 'ba5b5643-0efb-469b-b7ba-a578a21a18eb',
  CANCEL_BULK_PO_LINE_ITEM_UPDATE: '803aa7a4-14aa-4cc2-9068-80c67c248b86',
  CANCEL_BULK_PO_UPDATE: '2ef7f3ad-f380-4bfd-af16-683ea7751d9e',
};

export const ActionConstants: ActionConstantsInterface = {
  ...(AppEnvironment !== DEFAULT_APP_ENVIRONMENT ? ProdActions : QAActions),
};
